export default __webpack_public_path__ + "static/media/zamia.8c11d91e.svg";